<template>
    <div id="bloque1" style="width: 100vw;">
        <div class="loginBox">
          <img class="loginBoxImg"src="/dist/logo-login.png" >
          <p class="labels" id="titulo" style="font-weight: 400; font-size: 20px; margin-bottom: 20px">Cambiar contraseña</p> 
          <form @submit.prevent>
            <p class="labels">CONTRASEÑA ACTUAL</p>
            <input class="inputBox"  :class="{inputBoxInv: errorPassActual}"  type="password" v-model='passActual'> 
            <p class="labels">NUEVA CONTRASEÑA</p>
            <input class="inputBox"  :class="{inputBoxInv: errorPassNueva}" type="password" v-model='passNueva'>
            <p class="labels">REPITA NUEVA CONTRASEÑA</p>
            <input class="inputBox"  :class="{inputBoxInv: errorRepPassNueva}" type="password" v-model='repPassNueva'>
            <div style="height: 15px;">
              <p class="labels error" v-show='errorPassActual || errorPassNueva || errorRepPassNueva'>{{errorMsg}}</p>
            </div>
            <div id="btnContainer">
              <button id="btnRegistro" @click='btnCancelar'>CANCELAR</button>
              <button id="btnIngresar" @click="btnCambiar" >CAMBIAR</button>
            </div> 
          </form>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
    
  export default {
    
    name: 'Login',
    
    data () {
      return {
        passActual:'',
        passNueva:'',
        repPassNueva:'',
        errorPassActual:false,
        errorPassNueva:false,
        errorRepPassNueva:false,
        errorMsg:''
      }
    
    },
    
    methods: 
    {
      btnCambiar() {
        if (this.validar())
        {
           this.cambiarPass()
        } 
      },
    
      btnCancelar() {
          this.$router.go(-1);  
      },
    
    
      validar() {
        this.errorPassActual = false
        this.errorPassNueva = false
        this.errorRepPassNueva = false
        this.errorMsg = 'La contraseña debe tener al menos 6 caracteres'
        if (this.passActual.length < 6)
        {
          this.errorPassActual = true   
        }
        if (this.passNueva.length < 6)
        {
          this.errorPassNueva = true   
          this.errorRepPassNueva = true   
        }
        else if (this.repPassNueva != this.passNueva)
        {
          this.errorRepPassNueva = true   
          this.errorMsg = 'Error al repetir contraseña'
        }

        if ((!this.errorPassActual)&&(!this.errorPassNueva)&&(!this.errorRepPassNueva))
        {
          return true  
        }
        else
        {
          return false  
        }
      },
    
      cambiarPass() {
        this.$store.commit('loader/start')
        var pass = {'Password': this.passNueva}
        axios.post('/WebSalesContrasenia', pass ,{
          headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
          }
        )
         .then((response) => {
          this.$store.commit('loader/stop')
          if (response.data.Code == 0)
          {

            var obj = {
                        txt:'Su contraseña ha sido cambiada',
                        txtBtnCancel:'',
                        txtBtnOk:'Aceptar',
                        fCancel:null,
                        fOk:this.cambiarPassOk()
                      }
            this.$store.commit('popup/open',obj);
          }
          else if (response.data.Code == 99)
          {
            alert(response.data.Message) 
          }
          else
          {
            console.log(">>>>"+response.data.Message);
            alert(response.data.Message);  
          }
        })
        .catch((error) => {
          alert("error") 
          console.log(error);
        });
      },

      cambiarPassOk() {
        this.$router.go(-1);  
      }
    
    }
    
  }
    </script>
    
    
    <style scoped>
    
    *{
      margin:  0;
      padding: 0;
    }
    
    
    #bloque1{
      width:100%;
      height:100vh;
      background: linear-gradient(#005A9F , #1899D6);
    
    }
    
    
    .loginBox{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-width: 350px;
    width: 90vw;
    height: 370px;
    padding: 20px;
    border-radius: 15px;
    box-sizing: border-box;
    background-color: #ffffff;
    }
    
    
    .loginBoxImg{
    width: 100px;
    height: 100px;
    border-radius: 50%; 
    overflow: hidden;
    position: absolute;
    top: calc(-100px/2);
    left:calc(50% - 50px);
    }
    
    
    
    .labels
    {
      margin: 0;
      padding-bottom: 5px;
      font-weight: 500;
      font-size: 10px;
      color: #5c666f; 
    } 
    
    .error
    {
      color: #ff0000; 
    } 
    
    
    
    
    #titulo{
    margin-top: 40px;
    padding: 0,0,20px;  
    text-align: center;
    font-size: 20px;
    margin-bottom: 15px;
    }
    
    
    
    .inputBox
    {
      max-width: 305px;
      width: 75vw;
      margin-bottom: 20px;
      padding-left: 5px;
      border-radius: 5px;  
      margin-bottom: 10px;
      height:30px;
      border-style: solid;
      border:none; 
      border-width: 1px;
      border: 1px solid #dddddd;
    }
    
    
    .inputBoxInv
    {
      width: 305px;
      margin-bottom: 20px;
      padding-left: 5px;
      border-radius: 5px;  
      margin-bottom: 10px;
      height:30px;
      border-style: solid;
      border:none; 
      border-width: 1px;
      border: 1px solid #ff0000;
    }
    
    
    
    #btnContainer{
    margin-top: 20px;  
    text-align: center;
    }
    
    input[type="submit"]
    {
      height: 30px;
      font-size: 10px;
      font-weight: bold;
      border-radius: 20px;  
      border-style: solid;
      border:none; 
    }
    
    
    #btnRegistro{
      width: 100%;
      margin-bottom: 20px;
      margin-right: 5px;
      height: 30px;
      font-size: 10px;
      font-weight: bold;
      border-radius: 20px;  
      border-style: solid;
      border:none; 
      text-align: center;
      width: 100px;
      height: 30px;
      color: #5c666f;
      background: #ffffff; 
      border-width: 1px;
      border: 2px solid #5c666f;
      outline: none;
    }
    
    #btnIngresar{
      width: 100%;
      margin-bottom: 20px;
      margin-left: 5px;
      height: 30px;
      font-size: 10px;
      font-weight: bold;
      border-radius: 20px;  
      border-style: solid;
      border:none; 
      text-align: center;
      width: 80px;
      background: #44C7F4; 
      color: #ffffff;
      border-width: 1px;
      border: 2px solid #44C7F4;
      outline: none;
    }
    

    #btnIngresar:hover { cursor: pointer; }
    #btnRegistro:hover { cursor: pointer; }
    #forgetPass:hover { cursor: pointer; }
    
    
</style>
    


// WEBPACK FOOTER //
// src/components/views/home/configuracion.vue